<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="设置更新批次"
    width="300px"
    @show="showModal"
  >
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="small"
    >
      <el-form-item prop="batchNum">
        <el-select
          clearable
          v-model="form.batchNum"
          placeholder="请选择更新批次"
        >
          <el-option label="第一批" value="第一批"></el-option>
          <el-option label="第二批" value="第二批"></el-option>
          <el-option label="第三批" value="第三批"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认</el-button
    >
  </vxe-modal>
</template>
<script>
export default {
  name: 'SetBatchNumModal',
  props: {
    defaultVal: {
      type: String,
      default: '第一批'
    }
  },
  data() {
    return {
      formVisible: false,
      form: {
        batchNum: '',
      },
      rules: {
        batchNum: [
          { required: true, message: '请选择更新批次', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    showModal() {
      this.form.batchNum = this.defaultVal // 默认值


      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      this.$emit("sureHandler", this.form.batchNum);
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    },
  },
}
</script>
<style lang='less' scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>